import axios from 'axios';

/**
 * 신청 흐름 토큰(이름+이메일 인증, 3시간) 슬라이딩 갱신.
 * 현재 X-AUTH-TOKEN 이 유효하거나 최근(서버 grace 내) 만료면 subject 유지해 새 토큰 발급받아 store 반영.
 * @returns {Promise<boolean>} 갱신 성공 여부
 */
export async function refreshFlowToken() {
  try {
    const res = await axios.post('/api/public/work-permit/token/refresh');
    const tk = res && res.data && res.data.payload && res.data.payload.token;
    if (tk) {
      window.store.dispatch('auth/setAuth', tk);
      return true;
    }
  } catch (e) {
    // 갱신 불가(만료 과다/서명불일치/누락)
  }
  return false;
}

export default { refreshFlowToken };
